import { render } from "./TabAccountDetails.vue?vue&type=template&id=bffc9eb8"
import script from "./TabAccountDetails.js?vue&type=script&lang=js"
export * from "./TabAccountDetails.js?vue&type=script&lang=js"

import "./TabAccountDetails.scss?vue&type=style&index=0&lang=scss&scope=true"
/* custom blocks */
import block0 from "./TabAccountDetails.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FTabAccountDetails%2FTabAccountDetails.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__